// extracted by mini-css-extract-plugin
export default {"component":"b24839","facebook":"c24839","twitter":"d24839","blog":"e24839","youtube":"f24839","instagram":"g24839","socialMediaIcon":"h24839"};